/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'lock': {
    width: 1,
    height: 1,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="currentColor" fill-rule="evenodd" d="M8 2c1.65 0 3 1.35 3 3v2H5V5c0-1.65 1.35-3 3-3 0 0-1.65 0 0 0zm6 5h-1V5c0-2.76-2.24-5-5-5S3 2.24 3 5v2H2c-.55 0-1 .55-1 1.1V15c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V8.1c0-.55-.45-1.1-1-1.1z"/>'
  }
})
